import mockAxios, { AxiosResponse } from 'axios';

import { IVacationCarryOverRequestServiceMock } from './vacation-carry-over-request.mock.types';

export const mockVacationCarryOverRequestService = (): IVacationCarryOverRequestServiceMock => ({
  fetchVacationCarryOverRequests: jest.fn(),
  fetchVacationCarryOverRequest: jest.fn(),
  createVacationCarryOverRequest: jest.fn(),
  updateVacationCarryOverRequest: jest.fn(),
  deleteVacationCarryOverRequest: jest.fn(),

  // comments
  fetchVacationCarryOverRequestComments: jest.fn(),
  fetchVacationCarryOverRequestComment: jest.fn(),
  createVacationCarryOverRequestComment: jest.fn(),
  updateVacationCarryOverRequestComment: jest.fn(),
  deleteVacationCarryOverRequestComment: jest.fn(),

  addVacationCarryOverRequestCommentAttachments: jest.fn(),
  removeVacationCarryOverRequestCommentAttachment: jest.fn(),

  fetchVacationCarryOverRequestCommentsMentionableUsers: jest.fn(),

  fetchVacationCarryOverRequestActivities: jest.fn(),
  updateVacationCarryOverRequestState: jest.fn()
});

export const mockVacationCarryOverAxiosResponse = (): AxiosResponse<unknown> => ({
  data: undefined,
  status: 200,
  statusText: 'OK',
  headers: mockAxios.defaults.headers,
  config: mockAxios.defaults
});
